var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArticle1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 200,
    viewBox: "0 0 344 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_4118)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 344,
    height: 200,
    rx: 32,
    fill: "#23242C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.4578,
    cy: 100.248,
    r: 233.457,
    stroke: "#2D2F39",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.892,
    cy: 100.52,
    r: 167.311,
    transform: "rotate(163.414 123.892 100.52)",
    stroke: "#2D2F39",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.363,
    cy: 99.153,
    r: 95.7175,
    stroke: "#2D2F39",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249.42 114.949L242.048 89.458H246.624L252.216 110.871L258.062 89.458H262.637L268.484 110.871L274.076 89.458H278.651L271.28 114.949H265.942L260.35 94.7092L254.758 114.949H249.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.1 115.715C220.712 115.715 216.645 109.597 216.645 102.204C216.645 94.8118 220.712 88.6938 229.1 88.6938C237.488 88.6938 241.555 94.8118 241.555 102.204C241.555 109.597 237.488 115.715 229.1 115.715ZM221.22 102.204C221.22 109.597 224.779 112.656 229.1 112.656C233.421 112.656 236.98 109.597 236.98 102.204C236.98 94.8118 233.421 91.7528 229.1 91.7528C224.779 91.7528 221.22 94.8118 221.22 102.204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.58 114.95H209.259V81.8115H213.58V114.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.687 114.95H201.366V81.8115H205.687V114.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.901 115.715C178.513 115.715 174.446 109.597 174.446 102.204C174.446 94.8118 178.513 88.6938 186.647 88.6938C195.035 88.6938 198.34 95.0667 198.34 101.185V103.224H179.022C179.327 109.903 182.784 112.656 186.901 112.656C190.206 112.656 193.002 110.871 193.764 107.303H198.086C197.069 112.146 193.256 115.715 186.901 115.715ZM186.647 91.7528C182.733 91.7528 179.683 94.251 179.123 100.165H193.764C193.764 94.302 190.511 91.7528 186.647 91.7528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.827 114.95V81.8115H143.436L154.112 109.852L164.788 81.8115H171.397V114.95H167.075V86.4L156.145 114.95H152.078L141.148 86.4V114.95H136.827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 100,
    r: 33,
    fill: "url(#paint0_radial_48_4118)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.3042,
    cy: 100.052,
    rx: 27.5683,
    ry: 27.6196,
    fill: "url(#paint1_radial_48_4118)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.4368,
    cy: 100,
    rx: 20.6506,
    ry: 20.5994,
    fill: "url(#paint2_radial_48_4118)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.9542,
    cy: 100.051,
    r: 10.8121,
    fill: "url(#paint3_radial_48_4118)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_48_4118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90 100) rotate(90) scale(33)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E122B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252894,
    stopColor: "#131D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608015,
    stopColor: "#2750AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#A3EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_48_4118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.3042 100.052) rotate(90) scale(27.6196 27.5683)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F85F97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#330E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F00A38"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_48_4118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.4368 100) rotate(90) scale(20.5994 20.6506)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23164B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#15105D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939782,
    stopColor: "#2D68C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_48_4118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.9542 100.051) rotate(90) scale(10.8121)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB2354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#CE2C65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF94CE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_4118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 344,
    height: 200,
    rx: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArticle1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/article_1.83f1ee5725ac0192c3f7c50678286c43.svg";